export default {
  HANDOVER: 'HANDOVER',
  NO_HANDOVER: 'NO_HANDOVER',
  SELECTABLE: 'SELECTABLE',
};
